import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { TrackState } from './types';

const selectCache = (state: RootState) => state.trackCache;

export const selectTrackCounter = createSelector(
  selectCache,
  (cache: TrackState) => cache.trackCounter
);
